"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.tooltips.preview': 'Preview conversation',
    'conversations.tooltips.delete': 'Delete conversation',
};
